export enum HotelPromotionType {
  STAY_XPAY_Y = 'StayXPayY',
  PERCENT_DISCOUNT = 'PercentDiscount',
  VALUE_DISCOUNT = 'ValueDiscount',
  BANK_POS_PERCENT_DISCOUNT = 'BankPosPercentDiscount',
  BANK_POS_VALUE_DISCOUNT = 'BankPosValueDiscount',
  SETUR_POINT_EARN = 'SeturPointEarn',
  SETUR_POINT_USE = 'SeturPointUse',
  SETUR_POINT_COUPON = 'SeturPointCoupon',
  HOTEL_RUNNER_DISCOUNT = 'HotelRunnerDiscount',
}
